import { atom } from "jotai"
import { AddressType } from "./hqAddress"

export const defaultAddresses: AddressType[] = []

export const addressesDraftAtom = atom<AddressType[]>(defaultAddresses)
